/**
 * @generated SignedSource<<48f53d3615afeafb390386c1d7475530>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAreaBackgroundRulePanel_ProductNameQuery$variables = {
  id: string;
};
export type addAreaBackgroundRulePanel_ProductNameQuery$data = {
  readonly node: {
    readonly name?: string;
  } | null;
};
export type addAreaBackgroundRulePanel_ProductNameQuery = {
  response: addAreaBackgroundRulePanel_ProductNameQuery$data;
  variables: addAreaBackgroundRulePanel_ProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addAreaBackgroundRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "addAreaBackgroundRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b906929cf9ca522f08126f9b27d9eed",
    "id": null,
    "metadata": {},
    "name": "addAreaBackgroundRulePanel_ProductNameQuery",
    "operationKind": "query",
    "text": "query addAreaBackgroundRulePanel_ProductNameQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5dba9d7300c079afe46890b7545e0f4c";

export default node;
